import { IAdvancedFormConfig } from '~shared/modules/advanced-form/models/advanced-form.model';
import { BASE_BUSINESS_INFO_FORM_CONFIG } from './base-business-info.constant';

export const ADD_BUSINESS_INFO_FORM_CONFIG: IAdvancedFormConfig = {
  ...BASE_BUSINESS_INFO_FORM_CONFIG,
  legalText: 'PAGES.ACCOUNT.INFO.ADD_BUSINESS_INFO.LEGAL_TEXT',
  actionList: [
    {
      type: 'skip',
      text: 'PAGES.ACCOUNT.INFO.ADD_BUSINESS_INFO.BUTTON.SKIP',
    },
    {
      type: 'submit',
      text: 'PAGES.ACCOUNT.INFO.ADD_BUSINESS_INFO.BUTTON.SAVE',
    },
  ],
};
